import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IBuyerDeclineMeetingDateClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerDeclineMeetingDateClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/decline/meeting_date`;

export class BuyerDeclineMeetingDateClient implements IBuyerDeclineMeetingDateClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, match_id } = input;
        const method = 'POST';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ match_id: match_id });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
